import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';
import { Icon } from 'semantic-ui-react';
import StyledStreamModal from './StreamModal.style';

export const DEFAULT = {
  size: 'small'
};

class StreamModal extends PureComponent {
  state = {
    active: false
  };

  componentDidUpdate(prevProps) {
    if (prevProps.isOpen !== this.props.isOpen) {
      this.setState({ active: this.props.isOpen });
    }
  }

  render() {
    const {
      children,
      isOpen,
      toggleModal,
      theme,
      insetClose,
      ...rest
    } = this.props;
    const settings = { ...DEFAULT, ...rest };
    const closeModal = () => toggleModal(false);
    const modalCSS = cn('streammodal', theme && `streammodal--${theme}`, {
      'streammodal--active': this.state.active
    });

    return (
      <StyledStreamModal
        {...settings}
        open={isOpen}
        onClose={closeModal}
        className={modalCSS}
      >
        <Icon
          name="close"
          onClick={closeModal}
          className={insetClose ? 'close--inset' : ''}
        />
        {children}
      </StyledStreamModal>
    );
  }
}

StreamModal.propTypes = {
  children: PropTypes.node,
  isOpen: PropTypes.bool,
  toggleModal: PropTypes.func,
  theme: PropTypes.string,
  insetClose: PropTypes.bool
};
StreamModal.defaultProps = {
  insetClose: false
};
export default StreamModal;



// WEBPACK FOOTER //
// ./src/components/StreamModal/StreamModal.js